var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"list-btn"},[_c('Button',{attrs:{"type":"primary"},on:{"click":_vm.ret}},[_vm._v("返回")])],1),_vm._v(" "),_c('Table',{ref:"selection",attrs:{"border":"","columns":_vm.columns12,"data":_vm.data6,"loading":_vm.loading},on:{"on-selection-change":_vm.selection},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var row = ref.row;
var index = ref.index;
return undefined}}])}),_vm._v(" "),_c('div',{staticClass:"my-page"},[_c('page',{attrs:{"total":_vm.total},on:{"updatePage":_vm.updatePage,"updateSize":_vm.updateSize}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2136f9f1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jm/platform/finance/operOrderDetails.vue
// module id = null
// module chunks = 